import React, { Suspense, Fragment } from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { findOutEnv } from '@bitComponents/utils/environment';
import { giveRandomNumber } from '@bitComponents/utils/common';
import Page from './Page';

const LoadingMessage = () => null;

export const getModule = (myModules, key) => {
  const currentModule = myModules.find((module) => module.id === key);
  return currentModule.loader;
};
const generateSingleUuid = () => Math.random().toString(36).substr(2, 9);

export const generateUuid = () => {
  return (
    generateSingleUuid() +
    '-' +
    generateSingleUuid() +
    '-' +
    generateSingleUuid() +
    '-' +
    generateSingleUuid() +
    '-' +
    generateSingleUuid() +
    '-' +
    generateSingleUuid()
  );
};

const createRouter = (
  urlLibrary,
  modulesLibrary,
  contextData,
  projectId = '',
) => {
  const { name: enviromentKey } = findOutEnv();
  const pageList = urlLibrary.map((item) => item);
  return (
    <Suspense fallback={<LoadingMessage />}>
      <Switch>
        {pageList.map((pageData) => {
          if (pageData) {
            const {
              loader,
              pathName,
              exact,
              redirection,
              onlyDev,
              pageId,
              seoCustomValue,
              isBuyProcess,
              loggedPage,
              differentLoginStatusRedirect,
            } = pageData;

            let path2Use = pathName;
            if (pathName && pathName[enviromentKey]) {
              path2Use = pathName[enviromentKey];
            }
            const component = getModule(modulesLibrary, loader);
            let allowToShow = true;
            if (onlyDev) {
              allowToShow = enviromentKey === 'dev';
            }
            if (allowToShow) {
              // Redirect when login status is different to config
              let url2go = null;
              let loginStatusRedirect2Use = null;
              if (
                differentLoginStatusRedirect &&
                differentLoginStatusRedirect[enviromentKey]
              ) {
                loginStatusRedirect2Use =
                  differentLoginStatusRedirect[enviromentKey];
              }
              if (contextData && loginStatusRedirect2Use) {
                if (
                  (loggedPage && !contextData.userType) ||
                  (!loggedPage && contextData.userType)
                ) {
                  url2go = loginStatusRedirect2Use;
                  if (
                    document &&
                    document.location &&
                    document.location.search
                  ) {
                    const searchParams = document.location.search;
                    if (searchParams.indexOf('spaRedirect') === -1) {
                      url2go = `${url2go}${searchParams}&spaRedirect=true`;
                    } else {
                      url2go = `${url2go}${searchParams}`;
                    }
                  } else if (!document.location.search) {
                    url2go = `${url2go}?spaRedirect=true`;
                  }
                }
              }
              // END Redirect when login status is different to config
              if (component && !redirection && !url2go) {
                return path2Use.map((currentPathName) => {
                  return (
                    <Route
                      exact={exact}
                      key={`route-${currentPathName}-${giveRandomNumber(
                        1,
                        99,
                      )}`}
                      path={currentPathName}
                      render={(props) => {
                        const ComponentPage = component;
                        return (
                          <Fragment
                            key={`fragment-${currentPathName}-${giveRandomNumber(
                              1,
                              99,
                            )}`}
                          >
                            <Page
                              {...props}
                              key={`fragment-${currentPathName}-${giveRandomNumber(
                                1,
                                99,
                              )}`}
                              projectId={projectId}
                              pageId={pageId}
                              gaPageId={generateUuid()}
                              seoCustomValue={seoCustomValue}
                              context={contextData}
                              isBuyProcess={isBuyProcess}
                            />
                            <ComponentPage {...props} projectId={projectId} />
                          </Fragment>
                        );
                      }}
                    />
                  );
                });
              }
              if (redirection) {
                return (
                  <Route
                    key={`redirect${path2Use}`}
                    exact={exact}
                    path={`${path2Use}`}
                    render={() => <Redirect to={redirection} />}
                  />
                );
              }
              if (url2go) {
                let mustInjectRedirection = false;
                let myCurrentLocation = document.location.pathname;

                if (myCurrentLocation && myCurrentLocation.length) {
                  const lastChar =
                    myCurrentLocation[myCurrentLocation.length - 1];
                  if (lastChar !== '/') {
                    myCurrentLocation = `${myCurrentLocation}/`;
                  }
                }

                path2Use.forEach((itemPath) => {
                  if (
                    !mustInjectRedirection &&
                    itemPath === myCurrentLocation
                  ) {
                    mustInjectRedirection = true;
                  }
                });

                if (!mustInjectRedirection) {
                  return null;
                }

                return (
                  <Route
                    key={`redirect${url2go}`}
                    exact={exact}
                    path={myCurrentLocation}
                    render={() => <Redirect to={url2go} />}
                  />
                );
              }
              return null;
            }
          }

          return null;
        })}
      </Switch>
    </Suspense>
  );
};

export default createRouter;
